import React from 'react';
import './App.css';
import StudioBookingForm from './components/StudioBookingForm';

function App() {
  return (
    <div className="App">
        <StudioBookingForm />
    </div>
  );
}

export default App;
